export default __webpack_public_path__ + "assets/images/26b27e6447482e7a6ad300c6279b3bad-whatsapp-icon.svg";